import _ from "lodash";
export default function uniques(pets) {
    var result = [];
    var map = {};
    for (var _i = 0, pets_1 = pets; _i < pets_1.length; _i++) {
        var item = pets_1[_i];
        map[item.id] = item;
    }
    _.forEach(map, function (item) {
        result.push(item);
    });
    return result;
}
